/**
 * Enderecos publicos do produto, em um lugar so.
 *
 * A regra que motivou este arquivo: **o padrao de producao e a URL publica**,
 * e `localhost` so aparece sob `import.meta.env.DEV`. Antes era o contrario —
 * a landing tinha `?? 'http://localhost:3070/docs'` como padrao e a variavel
 * nunca era definida no build, entao o botao "Documentacao" em producao
 * mandava o visitante para a maquina dele.
 *
 * Com o padrao invertido, esquecer a variavel degrada para o endereco certo
 * em vez de degradar para um endereco que so existe na maquina de quem
 * programou.
 */

const dev = import.meta.env.DEV;

function endereco(valor: string | undefined, producao: string, local: string): string {
  if (valor) return valor;
  return dev ? local : producao;
}

/** Documentacao da API, com endereco proprio. */
export const DOCS_URL = endereco(
  import.meta.env.VITE_DOCS_URL as string | undefined,
  'https://documentacao.fanotas.com.br',
  'http://localhost:3070/docs',
);

/** Portal do cliente. */
export const PORTAL_URL = endereco(
  import.meta.env.VITE_PORTAL_URL as string | undefined,
  'https://app.fanotas.com.br',
  'http://localhost:5173',
);

/** API publica. */
export const API_URL = endereco(
  import.meta.env.VITE_API_URL as string | undefined,
  'https://api.fanotas.com.br',
  'http://localhost:3070',
);
